import React, { useEffect, useState } from 'react';
import { BwjPageContent } from '../../../../framework/components/bwj-page-content';
import { BwjPageHeader } from '../../../../framework/components/bwj-page-header';
import { AppRoutes } from '../../../app-routes';
import { BwjViewManager, BwjViewState } from '../../../../framework/components/bwj-view-manager';
import { ILowesStormDoorListing } from '../../../../entities-generated/models/lowes-storm-door/lowes-storm-door-listing';
import { LowesStormDoorApiClient } from '../../../../services/lowes-storm-door';
import { LowesStormDoorListItem } from '../../components/door-listing';
import { useNavigator } from '../../../../framework/services/navigation';

export const PageImportedLowesStormDoors: React.FunctionComponent = () => {
  const nav = useNavigator();
  const [viewState, setViewState] = useState(BwjViewState.Loading);
  const [doors, setDoors] = useState<ILowesStormDoorListing[]>([]);

  useEffect(() => {
    LowesStormDoorApiClient.getImportedStormDoorList()
    .then(doors => {
      setDoors(doors);
      setViewState(BwjViewState.Ready);
    })
    .catch(() => setViewState(BwjViewState.Error));
  }, []);

  const onDoorSelected = (door: ILowesStormDoorListing) => {
    nav.goTo(AppRoutes.publishLowesStormDoor.url(door.id));
  }
  
  return (
    <BwjViewManager
      state={viewState}
      loadingState={{
        message: 'Loading imports...',
      }}
      errorState={{
        message: 'An unexpected error occurred'
      }}
    >
      <BwjPageHeader
        title={'Imported Storm Doors (Lowe\'s)'}
        titleIconName={AppRoutes.importedLowesStormDoors.icon}
      />
      <BwjPageContent contentDescription={'primary content (no subcontent)'}>
        {doors.map(door =>
        <LowesStormDoorListItem
          key={door.id}
          listing={door}
          onClick={onDoorSelected}
        />)}
      </BwjPageContent>
    </BwjViewManager>
  );
};
